import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AngularFireModule } from '@angular/fire';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { environment } from '../environments/environment';

//Problema con reload
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';

import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';

// Componentes Públicos
import { AppComponent } from './app.component';
import { PagetopComponent } from './components/pagetop/pagetop.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { MenuComponent } from './components/menu/menu.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MenuItemComponent } from './components/menu-item/menu-item.component';

// Componentes Administración
import { CategoriaComponent } from './site/catalogos/categoria/categoria.component';
import { PlatillosComponent } from './site/catalogos/platillos/platillos.component';
import { PromocionesComponent } from './site/catalogos/promociones/promociones.component';
import { GalleryComponent } from './components/gallery/gallery.component';

// Services
import { CategoriasService } from './services/categorias.service';
import { PlatillosService } from './services/platillos.service';
import { GalleryService } from './services/gallery.service';
import { LoginComponent } from './admin/login/login.component';
import { RegisterComponent } from './admin/register/register.component';
import { AuthService } from './admin/auth.service';
import { AuthGuardService } from './admin/auth-guard.service';
import { UsersService } from './services/users.service';
import { CodesService } from './services/extras/codes.service';

import { AngularFireAnalyticsModule, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';

@NgModule({
  declarations: [
    AppComponent,
    PagetopComponent,
    NavbarComponent,
    MenuComponent,
    HeaderComponent,
    FooterComponent,
    MenuItemComponent,
    CategoriaComponent,
    PromocionesComponent,
    PlatillosComponent,
    GalleryComponent,
    LoginComponent,
    RegisterComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    ReactiveFormsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAnalyticsModule,
    AngularFireStorageModule,
  ],
  providers: [
    {provide: LocationStrategy, useClass: PathLocationStrategy},
    CategoriasService,
    PlatillosService,
    GalleryService,
    UsersService,
    AuthService,
    AuthGuardService,
    CodesService,

    ScreenTrackingService,
    UserTrackingService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
